<template>
    <v-btn-toggle borderless tile>
        <v-btn v-bind="{ disabled: disabled_decrease }" small text icon @click="decreaseZoom">
            <v-icon>mdi-minus</v-icon>
        </v-btn>
        <v-btn v-bind="{ disabled: disabled_increase }" small text icon @click="increaseZoom">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </v-btn-toggle>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    computed: {
        ...mapGetters("employment/form/page", ["disabled_decrease", "disabled_increase"]),
    },
    methods: {
        ...mapMutations("employment/form/page", ["decreaseZoom", "increaseZoom"]),
    },
};
</script>

<style></style>
